import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=400abfb4&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=400abfb4&prod&scoped=true&lang=scss"
import style1 from "./personalCenter.vue?vue&type=style&index=1&id=400abfb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400abfb4",
  null
  
)

export default component.exports